import { getBundleChargingModel } from './getBundleChargingModel';
import { getCreditsLimit, GetCreditsLimitParams } from './getCreditsLimit';

export interface GetPromoChargingModelParams extends GetCreditsLimitParams {}

export const getPromoChargingModel = ({
  bundleStatus,
  plans,
}: GetPromoChargingModelParams) =>
  getBundleChargingModel({
    bundleStatus,
    creditsLimit: getCreditsLimit({ bundleStatus, plans }),
    type: 'promo',
  });
